import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { AsYouType, CountryCode } from 'libphonenumber-js';
import { StringHelper } from '../helpers/string.helper';

@Directive({
  selector: '[appPhoneMask]'
})
export class PhoneMaskDirective {
  @Input() twoLetterCode!: string;

  constructor(public ngControl: NgControl) {}

  @HostListener('ngModelChange', ['$event'])
  public onModelChange(event: any): void {
    const asYouType: AsYouType = this.getFormatter();

    if (asYouType) {
      let newVal = StringHelper.getDigits(event?.toString() ?? '');

      // Number can have max 15 digits.
      if (newVal.length > 15) {
        newVal = newVal.substring(0, 15);
      }
      newVal = asYouType.input(newVal);

      this.ngControl.valueAccessor?.writeValue(newVal);
    }
  }

  private getFormatter(): AsYouType {
    // Cases match the two letter codes in the twoLetterCodes array in phone-type-form.component.ts
    return new AsYouType(this.twoLetterCode.toUpperCase() as CountryCode);
  }
}
